// extracted by mini-css-extract-plugin
export default {"backdrop":"Loading_backdrop__ruv0i","spinner":"Loading_spinner__h2m7+","spin":"Loading_spin__DAs37"};